// extracted by mini-css-extract-plugin
module.exports = {"reactionBadge":"Reactions_reactionBadge__DK14R","hasReacted":"Reactions_hasReacted__W2bn_"};